import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, EMPTY, mergeMap, of } from 'rxjs';
import { NOTIFICATION_SHOW, NOTIFICATION_SYNC_CHANGES, SERVICE_FAILURE } from '@store/actions';
import { Store } from '@ngrx/store';
import { NotificationService } from '@core/services';

@Injectable()
export class NotificationEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private notificationService: NotificationService,
  ) {}

  sync$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NOTIFICATION_SYNC_CHANGES),
      mergeMap(() => {
        return this.notificationService.sync().pipe(
          mergeMap(() => {
            return [
              NOTIFICATION_SHOW({ notification: { type: 'success', title: 'Success', detail: 'Changes successfully synchronized.' } }),
            ];
          }),
          catchError((error) => {
            return of(error).pipe(
              mergeMap((error) => {
                return [
                  SERVICE_FAILURE({ error }),
                ];
              })
            )
          })
        );
      }),
    )
  );

  serviceFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SERVICE_FAILURE),
        mergeMap(({ error : err })  => {
          const { error, message, statusCode } = err;
          const errors = Array.isArray(error) ? error : [message];

          if ([401, 408].includes(statusCode) && err.propagate)
            return EMPTY;

          return errors.map((error) => {
            return NOTIFICATION_SHOW({ notification: { type: 'error', title: 'Error', detail: error } });
          })
        })
      ),
  );
}